@if (userAccount || showForm) {
  <div class="section-1200" id="sample-collection-container">
    <div class="section-header">
      @if (!IsjwtCustomerLogin && userAccount) {
        <nav aria-label="breadcrumb" class="bredcrums">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active breadcrumb cursor" aria-current="page">
              <span (click)="redirectUrl()" (keypress)="redirectUrl()" tabindex="0"> Dashboard </span>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ submissionType === 'native-soil' ? 'Native Soil/Backfill' : 'Pre Cast Sample' }}
            Form</li>
          </ol>
        </nav>
      }
      @if (IsjwtCustomerLogin) {
        <nav aria-label="breadcrumb" class="bredcrums">
          <ol class="breadcrumb">
            <li class="breadcrumb-item active breadcrumb cursor" aria-current="page">
              <a class="c-primary ab" tabindex="0"[routerLink]="'/customer-submission/dashboard'"> Dashboard </a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ submissionType === 'native-soil' ? 'Native Soil/Backfill' : 'Pre Cast Sample' }}
            Form</li>
          </ol>
        </nav>
      }
      <div class="row mb-3 precast-row" [ngClass] = "{'s-head-container':!userAccount }">
        <div class="col-md-12">
          <h5 class="heading-sample">
            {{ submissionType === 'native-soil' ? 'Native Soil/Backfill' : 'Pre Cast Sample' }}
            Form
          </h5>
        </div>
        <p class="title-sampling">Sampling and Shipment of  {{ submissionType === 'native-soil' ? 'Native Soil/Backfill' : 'Pre Cast' }}
        Samples for Thermal Analysis</p>
      </div>
      <mat-stepper
        animationDuration="0ms"
        [@.disabled]="true"
        [linear]="'true'"
        #stepper
        [@.disabled]="true"
        (selectionChange)="stepChanged($event, stepper)">
        <mat-step [completed]="companyValid">
          <ng-template matStepLabel>Company Information</ng-template>
          @if (checkProjectStatuseLoadComaplete && autoLoadCheck && checkLoadForm && (companyInformation || isCreate)) {
            <app-company-information
              [makeEditable]="makeSampleEditable"
              [submissionType]="submissionType"
              [data]="companyInformation"
              (companyData)="getCompanyData($event)"
            (companyDuplicate) = "checkCompanyDuplicate($event)"></app-company-information>
          }
          <div class="stepper-buttons">
            <div class="float-right">
              <button class="mr-16" mat-raised-button (click)="onCancelButtonClick()">CANCEL</button>
              <button (click)="stepperNext(1)" mat-raised-button color="primary" [disabled]="isButtonDisabled()">
                NEXT
                <img class="arrow-right-space" src="/assets/icons/Arrow-right.svg" alt="arrow-right" />
              </button>
            </div>
            <div class="clearfix"></div>
          </div>
        </mat-step>
        <mat-step [completed]="sampleDataPrecastValid || sampleDataNativeValid">
          <ng-template matStepLabel>Sample Data</ng-template>
          @if (checkProjectStatuseLoadComaplete && (checkLoadForm && submissionType === 'native-soil') && (soilData || isCreate)) {
            <app-sample-data-nativesoil
              [data]="soilData"
              [makeEditable]="makeSampleEditable"
              (sampleDataNativeData)="getNativeData($event)"
              [nativeSampleType] = "nativeSampleType"
            ></app-sample-data-nativesoil>
          }
          @if (checkProjectStatuseLoadComaplete && (checkLoadForm && submissionType === 'precast' ) && (soilData || isCreate )) {
            <app-sample-data-precast
              [makeEditable]="makeSampleEditable"
              [data]="soilData"
              [companyData] = "company"
              [sampleTypes] = "preCastSampleTypes"
              (sampleDataPrecastData)="getPrecastData($event)"
              (sampleTypeSelected)="sampleTypeSelected($event)"
            ></app-sample-data-precast>
          }
          <div class="stepper-buttons">
            <div class="float-left">
              <button mat-raised-button (click)="stepperPrevious(0)">
                <img class="arrow-left-space" src="/assets/icons/Arrow-left.svg" alt="arrow-left" /> BACK
              </button>
            </div>
            <div class="float-right">
              <button class="mr-16" mat-raised-button (click)="onCancelButtonClick()">CANCEL</button>
              @if (submissionType === 'precast') {
                <button
                  (click)="stepperNext(2)"
                  mat-raised-button
                  color="primary"
                  [disabled]="!sampleDataPrecastValid">
                  NEXT
                  <img class="arrow-right-space" src="/assets/icons/Arrow-right.svg" alt="arrow-right" />
                </button>
              }
              @if (submissionType === 'native-soil') {
                <button
                  (click)="stepperNext(2)"
                  mat-raised-button
                  color="primary"
                  [disabled]="!sampleDataNativeValid">
                  NEXT
                  <img class="arrow-right-space" src="/assets/icons/Arrow-right.svg" alt="arrow-right" />
                </button>
              }
            </div>
            <div class="clearfix"></div>
          </div>
        </mat-step>
        <mat-step [completed]="commentsValid">
          <ng-template matStepLabel>Comments</ng-template>
          @if (checkLoadForm && commentStepperCheck && checkPrecastSampleType) {
            <app-requirement-comment
              [data]="requirementComment"
              (requirementData)="getInformationData($event)"
              [submissionType]="submissionType"
              [precastSampleTypes] = "preCastSampleTypes"
            ></app-requirement-comment>
          }
          <div class="stepper-buttons">
            <div class="float-left">
              <button mat-raised-button (click)="stepperPrevious(1)">
                <img class="arrow-left-space" src="/assets/icons/Arrow-left.svg" alt="arrow-left" />
                BACK
              </button>
            </div>
            <div class="float-right">
              <button mat-raised-button class="mr-16" (click)="onCancelButtonClick()">CANCEL</button>
              <button mat-raised-button color="primary" (click)="review(projectId, submissionType)">REVIEW</button>
            </div>
            <div class="clearfix"></div>
          </div>
        </mat-step>
      </mat-stepper>
    </div>
  </div>
}
